import React, { Component } from 'react';
import { connect } from 'react-redux';
import GetResponse from '../Response/GetResponse';
import GetError from '../Response/GetError';

import API from '../../../services/Api'

const mapStateToProps = state => {
    return { token: state };
};

const toJSON = ( form )  => {
    var object = {};
    form.forEach(function(value, key){
        object[key] = value;
    });
    return object;
}

class ConnectedChangeUser extends Component {
    constructor(props){
        super(props);

        this.state = {
            name: null,
            email: null,
            password: null,
            job: [],
            postalcode: null,
            error: null,
            response: null
        }

        // Handle Change
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangeJob = this.handleChangeJob.bind(this);
        this.handleChangePostalcode = this.handleChangePostalcode.bind(this);

        // Handle Submit
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        var clientsId = this.props.match.params.idUser
        API.getClient(clientsId).then(response => {
            var client = response.data.user
            this.setState({
                ...client
            })
        })
    }

    handleSubmit(event){
        event.preventDefault();

        // var form = new FormData();
        
        // if(this.state.id === null){
        //     this.setState({
        //         error: "Id Erreur"
        //     })
        //     return;
        // }

        // form.append("name", this.state.name);
        
        
        // if(this.state.email !== null){
        //     form.append("email", this.state.email);
        // }
        // if(this.state.password !== null){
        //     form.append("password", this.state.password);
        // }
        // if(this.state.right !== null){
        //     form.append("right", this.state.right);
        // }
        // if(this.state.postalcode !== null){
        //     form.append("postalcode", this.state.postalcode);
        // }
        
            
    //     var xdr = new XMLHttpRequest(); 
         
    //     xdr.responseType = 'json';
    //     xdr.open("POST", this.props.app.dns+'/admin/user/change/', true);
    //     xdr.setRequestHeader("Authorization", "Bearer "+this.props.token);
    //     xdr.send(form);

    //     xdr.onload = () => {
    //         this.setState({
    //             response: xdr.response
    //         })
    //     }

    //     xdr.onerror = () => {
    //         this.setState({
    //             error: xdr.error
    //         })
    //     }

    API.modifyClient(this.props.match.params.idUser, {
        ...this.state,
        email : this.state.email,
        name: this.state.name,
        job: Number(this.state.job) || 0,
        postalcode: Number(this.state.postalcode) || 0
    }).then(res => {
        var response = res.data
        this.setState({response})
    })

    }

    handleChangeName(event) {
        this.setState({name: event.target.value});
    }

    handleChangeEmail(event) {
        this.setState({email: event.target.value});
    }
    handleChangePassword(event) {
        this.setState({password: event.target.value});
    }
    
    handleChangeJob(event, val) {
        this.setState({job: event.target.value});
    }
    handleChangePostalcode(event) {
        this.setState({postalcode: event.target.value});
    }

    render() {
        let condition = (this.state.error !== null);
        let responseCondition = (this.state.response !== null);
        let errorCondition = (this.state.error !== null);

        return (
            <div className="ui container">
                <div className="ui center aligned container">
                <br/>
                <h1 className="ui header">User Area</h1>
                <h2 className="ui header">Update</h2>
                <br/>
                </div>

                {condition ? (
                    <div className="ui divided three column grid">
                        <div className="row">
                            <div className="column">
                            </div>
                            <div className="ui column segment" >
                                <div className="ui center aligned container" >
                                    <div className="ui negative message">
                                        <div className="header">{this.state.error}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ): (
                    <div></div>
                )}

                <div className="ui container stackable three column grid">
                    <div className="ui column">
                    </div>
                    <div className="ui column">
                        <form className="ui form" onSubmit={this.handleSubmit}>
                            <div className="field">
                                <label>NOM</label>
                                <input onChange={this.handleChangeName} value={this.state.name}/>
                            </div>
                            <div className="field">
                                <label>E-MAIL ADRESS</label>
                                <input type="email" onChange={this.handleChangeEmail} value={this.state.email}/>
                            </div>
                            <div className="field">
                                <label>MOT DE PASSE</label>
                                <input type="password" onChange={this.handleChangePassword} value={this.state.password}/>
                            </div>
                            <div className="field">
                                <label>CATEGORIE</label>
                                <select onChange={this.handleChangeJob} value={this.state.job}>
                                    <option value="0">Administrateur</option>
                                    <option value="3">Entreprises</option>
                                    <option value="2">Prescripteurs</option>
                                    <option value="1">Commerciaux</option>
                                    <option value="4">Particulier</option>
                                </select>
                            </div>
                            <div className="field">
                                <label>CODE POSTAL</label>
                                <input onChange={this.handleChangePostalcode} value={this.state.postalcode}/>
                            </div>

                            <button type="submit" className="ui button" role="button">EDITER</button>
                        </form>
                    </div>
                </div>

                {responseCondition ? (
                    <GetResponse data={this.state} />
                ):(
                    <div></div>
                )}

                {errorCondition ? (
                    <GetError data={this.state} />
                ): (
                    <div></div>
                )}

            </div>
        );
    }
}

const ChangeUser = connect(mapStateToProps)(ConnectedChangeUser);

export default ChangeUser;



// WEBPACK FOOTER //
// ./src/components/Protected/User/EditCompte.jsx